import Cotacoes from "./cotacoes";

export default Cotacoes;
